/*
* @requires  seq.js
* @requires  base64.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function setAttrs(dest,src,attrs) {
        for(var i=0;i<attrs.length;i++){
            if(src[attrs[i]]!==undefined){
                dest[attrs[i]]=src[attrs[i]];
            }
        }
    }

    function setAttrsDefault(dest,src,attrs,defaults) {
        for(var i=0;i<attrs.length;i++){
            if(src[attrs[i]]!==undefined){
                dest[attrs[i]]=src[attrs[i]];
            }else {
                dest[attrs[i]]=defaults[i];
            }
        }
    }

    function success(param,ret){
        if(param && param.success){
            param.success(ret);
        }
    }

    function fail(param,e){
        if(param && param.fail){
            param.fail(e);
        }
    }

    function getCookie(c_name) {
        var cookieValue=document.cookie;

        if (cookieValue && cookieValue.length>0)
        {
            var c_start=cookieValue.indexOf(c_name + "=");
            if (c_start!==-1)
            {
                c_start=c_start + c_name.length+1;
                var c_end=cookieValue.indexOf(";",c_start);
                if (c_end===-1)
                    c_end=cookieValue.length;

                return unescape(cookieValue.substring(c_start,c_end));
            }
        }

        return null;
    }

    function setCookie(c_name,value,longKeep,expiredays)
    {
        if(value==null || value===undefined){
            deleteCookie(c_name);
            return;
        }

        if(!longKeep){
            if(!$m.util._cookies){
                $m.util._cookies=[];
                $m.util._cookies.push(c_name);
            }
            else{
                var find=false;
                for(var i=0;i<Util._cookies.length;i++){
                    if($m.util._cookies[i]===c_name){
                        find=true;
                        break;
                    }
                }
                if(!find){
                    $m.util._cookies.push(c_name);
                }
            }
        }

        var cookieValue=c_name+ "=" +escape(value);
        if(expiredays!==null){
            var d = new Date();
            d.setTime(d.getTime() + (expiredays * 24 * 60 * 60 * 1000));
            cookieValue+=";expires="+d.toGMTString();
        }

        document.cookie=cookieValue;
    }

    function deleteCookie(name){
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cookieValue=name + "=null;expires="+exp.toGMTString();

        document.cookie=cookieValue;
    }

    function cleanCookie(){
        if($m.util._cookies){
            for(var i=0;i<$m.util._cookies.length;i++){
                var name=$m.util._cookies[i];
                deleteCookie(name);
            }
        }
    }

    function getLocal(name){
        var v=null

        //sessionStorage中查找
        if(window.sessionStorage){
            v=sessionStorage.getItem(name)
        }

        //localStorage中查找
        if(!v) {
            if(window.localStorage){
                v=localStorage.getItem(name)
            }
        }

        //cookie中查找，IE不支持sessionStorage，localStorage，只能使用cookie
        if(!v){
            v=getCookie(name)
        }

        return v
    }

    function setLocal(name,value,keepTime){
        if(keepTime==="long"){
            if(window.localStorage){
                localStorage.setItem(name,value)
            } else {
                setCookie(name,value,true,365)
            }

        } else {
            if(window.sessionStorage){
                sessionStorage.setItem(name,value)
            } else {
                setCookie(name,value,false)
            }
        }
    }

    function removeLocal(name){
        if(window.localStorage){
            localStorage.removeItem(name)
        }
        if(window.sessionStorage){
            sessionStorage.removeItem(name)
        }
        deleteCookie(name)
    }

    function isFirefox() {
        if(navigator.userAgent.toLowerCase().indexOf("firefox") != -1)
            return true;
        else
            return false;
    }

    function isIE(){
        if(!!window.ActiveXObject || "ActiveXObject" in window){
            return true;
        }else{
            return false;
        }
    }

    function ieVersion() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if(fIEVersion === 7) {
                return 7;
            } else if(fIEVersion === 8) {
                return 8;
            } else if(fIEVersion === 9) {
                return 9;
            } else if(fIEVersion === 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }
        } else if(isEdge) {
            return 'edge';//edge
        } else if(isIE11) {
            return 11; //IE11
        }else{
            return -1;//不是ie浏览器
        }
    }

    function formatDate(d,fmt) {
        var o = {
            "M+": d.getMonth() + 1, //月份
            "d+": d.getDate(), //日
            "h+": d.getHours(), //小时
            "m+": d.getMinutes(), //分
            "s+": d.getSeconds(), //秒
            "q+": Math.floor((d.getMonth() + 3) / 3), //季度
            "S": d.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    }

    $m.util={
        setAttrs: setAttrs,
        setAttrsDefault: setAttrsDefault,
        success: success,
        fail: fail,
        _cookies: null,
        getCookie: getCookie,
        setCookie:setCookie,
        deleteCookie:deleteCookie,
        cleanCookie:cleanCookie,
        getLocal:getLocal,
        setLocal:setLocal,
        removeLocal:removeLocal,
        isFirefox:isFirefox,
        isIE: isIE,
        ieVersion: ieVersion,
        formatDate: formatDate,
    };

})(HebcaMiddleware);
